export default __webpack_public_path__ + "static/media/sound.2e9ed399.svg";